import * as Yup from "yup";

export const SignInValidator = Yup.object().shape({
  email: Yup.string()
    .required("User name/Email is required.")
    .email("Invalid email address"),
  password: Yup.string().required("Password is required."),
});
